export const state = {
  // product: undefined,
  // products: []
  tarif: {},
  tarifs: [],
  pagination:''
}
